import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES, type LanguageCode } from './i18n/config';

export type Route = 'home' | 'features' | 'pricing' | 'download' | 'privacy' | 'terms' | 'contact';

const SUPPORTED_CODES = SUPPORTED_LANGUAGES.map(lang => lang.code);

export function isSupportedLanguage(code: string | null | undefined): code is LanguageCode {
  if (!code) return false;
  return SUPPORTED_CODES.includes(code as LanguageCode);
}

export function normalizePathname(pathname: string): string {
  if (!pathname) return '/';
  let normalized = pathname.startsWith('/') ? pathname : `/${pathname}`;
  if (normalized.length > 1 && normalized.endsWith('/')) {
    normalized = normalized.slice(0, -1);
  }
  return normalized;
}

export function parsePath(pathname: string): { lang: LanguageCode | null; route: Route } {
  const normalized = normalizePathname(pathname);
  const parts = normalized.split('/').filter(Boolean);
  let lang: LanguageCode | null = null;
  let route: Route = 'home';

  if (parts.length > 0 && isSupportedLanguage(parts[0])) {
    lang = parts[0] as LanguageCode;
    parts.shift();
  }

  if (parts[0] === 'features') route = 'features';
  else if (parts[0] === 'pricing') route = 'pricing';
  else if (parts[0] === 'download') route = 'download';
  else if (parts[0] === 'privacy') route = 'privacy';
  else if (parts[0] === 'terms') route = 'terms';
  else if (parts[0] === 'contact') route = 'contact';

  return { lang, route };
}

export function buildPath(lang: LanguageCode | null, route: Route): string {
  const prefix = lang ? `/${lang}` : '';
  if (route === 'features') return `${prefix}/features/`;
  if (route === 'pricing') return `${prefix}/pricing/`;
  if (route === 'download') return `${prefix}/download/`;
  if (route === 'privacy') return `${prefix}/privacy/`;
  if (route === 'terms') return `${prefix}/terms/`;
  if (route === 'contact') return `${prefix}/contact/`;
  return `${prefix}/`;
}

export function getDefaultLanguage(): LanguageCode {
  return DEFAULT_LANGUAGE;
}

export function redirectTo(url: string) {
  if (typeof window === 'undefined') return;
  window.location.replace(url);
}
